// // src/components/AboutHero.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaArrowRight, FaStar } from 'react-icons/fa';

// const AboutHero = () => {
//   // Aapki background image
//   const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772790629/Gemini_Generated_Image_vjkf7ivjkf7ivjkf_uizggj.png";

//   return (
//     <section className="relative h-screen flex items-center justify-center overflow-hidden">
//       {/* Fixed Background Image with Parallax Effect */}
//       <div 
//         className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
//         style={{
//           backgroundImage: `url('${backgroundImage}')`,
//           backgroundPosition:"50% 50%",
//         }}
//       >
//         {/* Dark Overlay for text readability */}
//         <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
        
//         {/* Subtle gradient overlay for depth */}
//         <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40"></div>
//       </div>

//       {/* Content */}
//       <div className="container-custom relative z-10">
//         <div className="text-center text-white 2xl:space-y-8 max-w-5xl mx-auto">
          
//           {/* "ABOUT US" Badge */}
//           {/* <div className="animate-fade-in-up">
//             <span className="inline-block bg-[#c9a86c]/20 backdrop-blur-sm text-[#c9a86c] px-6 py-2 rounded-full text-sm font-semibold border border-[#c9a86c]/30 tracking-wider">
//               ✦ ABOUT US ✦
//             </span>
//           </div> */}

//           {/* Main Heading - Two lines with gold accent */}
//           <h1 className="text-5xl  md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
//             <span className="">Stay IN.</span>
//             <span className="font-bold text-[#c9a86c] mt-2">Experience More.</span>
//           </h1>

//           {/* Description */}
//           {/* <p className="text-md 2xl:text-2xl mb-10 max-w-7xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
//             Experience refined living at Stay IN Hospitality — premium fully furnished serviced apartments located in the iconic Centaurus, Islamabad. Designed for business professionals, families, couples, and distinguished guests seeking comfort, privacy, and convenience.
//           </p> */}

//             <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
//             Whether your visit is for corporate meetings, family vacations, special occasions, or extended stays, Stay IN ensures a seamless and personalized hospitality experience.
//           </p>


//           {/* CTA Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
//             {/* <Link
//               to="/about"
//               className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//             >
//               <span>Our Story</span>
//               <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
//             </Link> */}
//             <Link
//               to="/contact"
//               className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
//             >
//               Contact Us
//             </Link>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutHero;



// src/components/AboutHero.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaStar } from 'react-icons/fa';

const AboutHero = () => {
  // Aapki background image
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772790629/Gemini_Generated_Image_vjkf7ivjkf7ivjkf_uizggj.png";

  return (
    <>
      {/* SEO Meta Tags for About Page */}
      <Helmet>
        <title>About StayIN | Luxury Serviced Apartments Centaurus Islamabad</title>
        <meta name="description" content="StayIN Hospitality - Premium serviced apartments in Centaurus Islamabad since 2024. Experience refined living with stunning Faisal Mosque views, 5-star amenities, and personalized hospitality for business & leisure travelers." />
        <meta name="keywords" content="about StayIN, StayIN Hospitality, serviced apartments Islamabad, Centaurus Islamabad apartments, luxury accommodation Islamabad, StayIN Centaurus, premium apartments Islamabad" />
        
        {/* Open Graph for About Page */}
        <meta property="og:title" content="About StayIN | Luxury Serviced Apartments Centaurus Islamabad" />
        <meta property="og:description" content="Premium serviced apartments in Centaurus Islamabad since 2024. Experience refined living with stunning Faisal Mosque views and 5-star amenities." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://stayinhospitality.com/about-us" />
        <meta property="og:image" content={backgroundImage} />
        <meta property="og:image:alt" content="StayIN Luxury Serviced Apartments in Centaurus Islamabad" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About StayIN | Luxury Serviced Apartments Centaurus Islamabad" />
        <meta name="twitter:description" content="Premium serviced apartments in Centaurus Islamabad since 2024. Experience refined living with stunning Faisal Mosque views." />
      </Helmet>

      {/* About Page Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About StayIN Centaurus Serviced Apartments",
          "description": "StayIN Hospitality delivers premium fully furnished serviced apartments in Centaurus, Islamabad since 2024. Designed for business professionals, families, couples, and distinguished guests seeking comfort, privacy, and convenience.",
          "url": "https://stayinhospitality.com/about-us",
          "mainEntity": {
            "@type": "Organization",
            "name": "StayIN Hospitality",
            "foundingDate": "2024",
            "description": "Luxury serviced apartment provider in Centaurus Islamabad",
            "location": {
              "@type": "Place",
              "name": "The Centaurus Mall, Islamabad",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Centaurus Complex, Jinnah Avenue",
                "addressLocality": "Islamabad",
                "addressCountry": "PK"
              }
            },
            "makesOffer": {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Luxury Serviced Apartments",
                "description": "Fully furnished serviced apartments with Faisal Mosque views"
              }
            }
          }
        })}
      </script>

      <section 
        className="relative h-screen flex items-center justify-center overflow-hidden"
        aria-label="About StayIN - Luxury serviced apartments in Centaurus Islamabad"
      >
        {/* Fixed Background Image with Parallax Effect */}
        <div 
          className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
            backgroundPosition: "50% 50%",
          }}
        >
          {/* Dark Overlay for text readability */}
          <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
          
          {/* Subtle gradient overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40"></div>
        </div>

        {/* Content */}
        <div className="container-custom relative z-10">
          <div className="text-center text-white 2xl:space-y-8 max-w-5xl mx-auto">
            
            {/* Main Heading - Two lines with gold accent */}
            <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
              <span className="block">Stay IN.</span>
              <span className="font-bold text-[#c9a86c] mt-2 block">Experience More.</span>
            </h1>

            {/* Description */}
            <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
              Whether your visit is for corporate meetings, family vacations, special occasions, or extended stays, Stay IN ensures a seamless and personalized hospitality experience.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
                aria-label="Contact StayIN for luxury apartment bookings and inquiries"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutHero;